import { apiClient } from "@/lib/api-client";

export interface IkuMultiplierMap {
  [ikuKey: string]: {
    [jabatanKey: string]: number;
  };
}

export interface ConfigMultiplierResponse {
  data: IkuMultiplierMap;
  message: string;
}

export const getConfigMultipliers = async (): Promise<IkuMultiplierMap> => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;
  const res = await apiClient(`${baseUrl}/api/v1/config/multipliers`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });
  return (res as ConfigMultiplierResponse).data;
};
